import { useEffect, useState } from 'react';
import './StatusBar.css';

const StatusBar = ({ message, isError }) => {
  const [timestamp, setTimestamp] = useState('');
  const [isVisible, setIsVisible] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const now = new Date();
    setTimestamp(now.toLocaleTimeString());
    
    // Reset visibility when message changes
    setIsVisible(true);
    setIsFading(false);

    // Start fade after 10 seconds
    const fadeTimer = setTimeout(() => {
      setIsFading(true);
    }, 10000);

    // Complete fade and hide after 15 seconds (10s wait + 5s fade)
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 15000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, [message]);

  if (!isVisible) return null;

  return (
    <div className={`status-bar ${isError ? 'error' : ''} ${isFading ? 'fading' : ''}`}>
      <span className="status-timestamp">{timestamp}</span>
      <span className="status-message">{message}</span>
    </div>
  );
};

export default StatusBar;